import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import LoginGoogle from "../Components/Login/LoginGoogle";
import LoginEmail from "../Components/Login/LoginEmail";
import AuthContext from "../store/auth-context";
import LoginFacebook from "../Components/Login/LoginFacebook";

import "./LoginPage.css";

const LoginPage = (props) => {
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="contenitore_login">
        <h1>Accedi</h1>

        <div className="form_login">
          <LoginEmail
            cfg={props.cfg}
            token={props.token}
            sessionKey={props.sessionKey}
            userUpdate={props.userUpdate}
            wsCall={props.wsCall}
          />
        </div>
        <div className="Google_login">
          <LoginGoogle
            cfg={props.cfg}
            token={props.token}
            sessionKey={props.sessionKey}
            userUpdate={props.userUpdate}
            wsCall={props.wsCall}
          />
        </div>
        <div className="Facebook_login">
          <LoginFacebook
            cfg={props.cfg}
            token={props.token}
            sessionKey={props.sessionKey}
            userUpdate={props.userUpdate}
            wsCall={props.wsCall}
          />
        </div>
        <div className="registrazione_login">
          <p>Oppure:</p>
          <div>
            <Link to="/registrazione">
              <p>REGISTRATI</p>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default LoginPage;
